import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { offerCardsApi } from '../api/offer-cards.api';
import type { OfferCard } from '../interfaces/offer-card.interface';

interface UseOfferCardsResult {
  data: OfferCard[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function useOfferCards(): UseOfferCardsResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<OfferCard[]>({
    queryKey: ['offers', 'cards', selectedCompanyId, direction],
    queryFn: () => offerCardsApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
